import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Survey\GetSurveyListController::__invoke
* @see app/Http/Controllers/Survey/GetSurveyListController.php
* @route '/api/surveys'
*/
const GetSurveyListController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetSurveyListController.url(options),
    method: 'get',
})

GetSurveyListController.definition = {
    methods: ["get","head"],
    url: '/api/surveys',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Survey\GetSurveyListController::__invoke
* @see app/Http/Controllers/Survey/GetSurveyListController.php
* @route '/api/surveys'
*/
GetSurveyListController.url = (options?: RouteQueryOptions) => {
    return GetSurveyListController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Survey\GetSurveyListController::__invoke
* @see app/Http/Controllers/Survey/GetSurveyListController.php
* @route '/api/surveys'
*/
GetSurveyListController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetSurveyListController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Survey\GetSurveyListController::__invoke
* @see app/Http/Controllers/Survey/GetSurveyListController.php
* @route '/api/surveys'
*/
GetSurveyListController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetSurveyListController.url(options),
    method: 'head',
})

export default GetSurveyListController